import { accUnaccLabels } from "@/lib/transformers/UnaccompaniedTransformer";
import { PriceListRow } from "../types/PriceListRow";

export const formatUnaccompanied = (
  unaccompanied: string | null | undefined
) => {
  switch (unaccompanied) {
    case "Y":
      return accUnaccLabels.UNACC;
    case "N":
      return accUnaccLabels.ACC;
    case null:
    case undefined:
    case "":
      return accUnaccLabels.BOTH;
    default:
      return unaccompanied;
  }
};

/**
 * The backend reads currencies case-insensitively, so a row quoted in the
 * currency asked for is not converted even if the two differ in case.
 */
export const isConvertedPrice = (
  row: Pick<PriceListRow, "routeAgreementCurrency">,
  conversionCurrency: string
) =>
  row.routeAgreementCurrency.toUpperCase() !== conversionCurrency.toUpperCase();

export const priceLabel = (conversionCurrency: string | undefined) =>
  conversionCurrency ? `Price (${conversionCurrency})` : "Price";

/** Movement type "M" marks a route agreement as intermodal. */
export const isIntermodal = (row: Pick<PriceListRow, "movementType">) =>
  row.movementType === "M";
